import { useEffect, useState } from "react";
import { Notification } from "./components/Notification";
import { useAuth } from "./contexts/AuthProvider/useAuth";
import { Login } from "./pages/Login";
import { Principal } from "./pages/Principal";
import { ThemeProviderWrapper } from "./theme";
import { useLocation } from "react-router-dom";
import { PdfSigner } from "./pages/Signature";

function App() {
  const auth = useAuth();
  const location = useLocation();
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (auth.usunome !== null)
      setLoading(false);
  }, [auth.usunome]);

  if (loading)
    return <div>Loading...</div>;

  return (
    <ThemeProviderWrapper>
      {
        location.pathname.startsWith("/signature-form") ? <PdfSigner /> :
          !auth.token ? <Login /> : <Principal />
      }

      < Notification />
    </ThemeProviderWrapper>
  );
}

export default App;
